import { render } from "./SubjectsView.vue?vue&type=template&id=207fe9fb"
import script from "./SubjectsView.vue?vue&type=script&lang=js"
export * from "./SubjectsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__